import { FolderPlus, Plus, X } from "lucide-react";
import React, { useState } from "react";
import { useLocalLibraryStore } from "../../stores/localLibraryStore";
import { Track } from "../../types";

interface AddToAlbumDialogProps {
  isOpen: boolean;
  onClose: () => void;
  track: Track;
}

export const AddToAlbumDialog: React.FC<AddToAlbumDialogProps> = ({ isOpen, onClose, track }) => {
  const [newAlbumName, setNewAlbumName] = useState("");
  const { getAllAlbums, addToAlbum } = useLocalLibraryStore();
  const albums = getAllAlbums();

  if (!isOpen) return null;

  const handleAddToExisting = (albumName: string) => {
    addToAlbum(albumName, track);
    onClose();
  };

  const handleCreateNew = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newAlbumName.trim()) return;
    addToAlbum(newAlbumName.trim(), track);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-zinc-900 rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-3">
            <FolderPlus className="w-6 h-6" />
            <h2 className="text-xl font-bold">Add to Album</h2>
          </div>
          <button onClick={onClose} className="text-zinc-400 hover:text-white">
            <X className="w-6 h-6" />
          </button>
        </div>

        {albums.length > 0 && (
          <>
            <h3 className="text-sm font-medium text-zinc-400 mb-2">Existing Albums</h3>
            <div className="space-y-2 mb-6">
              {albums.map((album) => (
                <button
                  key={album.name}
                  onClick={() => handleAddToExisting(album.name)}
                  className="w-full px-4 py-2 text-left bg-zinc-800 hover:bg-zinc-700 rounded-md transition flex items-center justify-between"
                >
                  <span>{album.name}</span>
                  <span className="text-sm text-zinc-400">{album.tracks.length} tracks</span>
                </button>
              ))}
            </div>
          </>
        )}

        <div className="border-t border-zinc-800 my-6" />

        <form onSubmit={handleCreateNew}>
          <h3 className="text-sm font-medium text-zinc-400 mb-2">Create New Album</h3>
          <div className="flex gap-2">
            <input
              type="text"
              value={newAlbumName}
              onChange={(e) => setNewAlbumName(e.target.value)}
              placeholder="Album name"
              className="flex-1 px-4 py-2 bg-zinc-800 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500"
            />
            <button
              type="submit"
              disabled={!newAlbumName.trim()}
              className="px-4 py-2 bg-yellow-500 text-white rounded-full hover:bg-yellow-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Plus className="w-5 h-5" />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
